import {
  ChevronDoubleLeftIcon,
  ChevronDoubleRightIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  ArrowUpTrayIcon,
} from "@heroicons/react/24/outline";

import Papa from "papaparse";

// exportdata from there

import { useExportData } from "react-table-plugins";
import JsPDF from "jspdf";
import "jspdf-autotable";
import React, { useEffect, useMemo } from "react";
import {
  useTable,
  usePagination,
  useSortBy,
  useGlobalFilter,
  useAsyncDebounce,
} from "react-table";

function GlobalFilter({
  preGlobalFilteredRows,
  globalFilter,
  setGlobalFilter,
  exportData,
}) {
  const count = preGlobalFilteredRows.length;
  const [value, setValue] = React.useState(globalFilter);
  const onChange = useAsyncDebounce((value) => {
    setGlobalFilter(value || undefined);
  }, 200);

  return (
    <div className="flex flex-row justify-between items-center gap-2 p-1">
      <span className=" text-sm  p-2">Search:</span>
      <input
        className="flex-1 w-full text-sm p-2 focus:outline-none"
        value={value || ""}
        onChange={(e) => {
          setValue(e.target.value);
          onChange(e.target.value);
        }}
        placeholder={`${count} records...`}
      />
      <button
        onClick={() => {
          exportData("csv", true);
        }}
        type="button"
        className="block rounded-md bg-gray-600 py-2 px-3 text-center text-sm  text-white  hover:bg-gray-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-600"
      >
        <ArrowUpTrayIcon className="h-4 w-4 inline-block text-white mr-1" />
        Export
      </button>
    </div>
  );
}

const Table = ({ columns, data, actions, name = "data" }) => {
  const [sortBy, setSortBy] = React.useState([
    localStorage.getItem("sort")
      ? JSON.parse(localStorage.getItem("sort"))
      : "",
  ]);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    preGlobalFilteredRows,
    setGlobalFilter,
    visibleColumns,
    exportData,
    state: { pageIndex, pageSize, globalFilter },
  } = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: 0, sortBy: sortBy },
      getExportFileBlob,
      getExportFileName,
    },
    useGlobalFilter,
    useSortBy,
    usePagination,
    useExportData
  );

  function getExportFileName({ fileType, all }) {
    if (fileType === "csv") {
      return `${name.toLowerCase()}`; // Set the desired file name for CSV exports
    }
    return "data";
  }
  function getExportFileBlob({ columns, data, fileType, fileName }) {
    if (fileType === "csv") {
      const headerNames = columns.map((col) => col.exportValue);
      const csvString = Papa.unparse({ fields: headerNames, data });
      return new Blob([csvString], { type: "text/csv" });
    }

    // Other formats goes here
    return false;
  }

  const totalCount = useMemo(() => data.length, [data]);

  useEffect(() => {
    const sort = localStorage.getItem("sort")
      ? JSON.parse(localStorage.getItem("sort"))
      : "";
    if (sort.length == 0) {
      setSortBy(sort);
    }
  }, [sortBy]);

  return (
    <>
      {" "}
      <table
        {...getTableProps()}
        className="min-w-full divide-y divide-gray-300"
      >
        <thead>
          <tr>
            <th colSpan={visibleColumns.length + 1} className="border">
              <GlobalFilter
                preGlobalFilteredRows={preGlobalFilteredRows}
                globalFilter={globalFilter}
                setGlobalFilter={setGlobalFilter}
                exportData={exportData}
              />
            </th>
          </tr>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th
                  {...column.getHeaderProps(column.getSortByToggleProps())}
                  scope="col"
                  className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 whitespace-nowrap"
                >
                  <span>
                    {column.isSorted
                      ? column.isSortedDesc
                        ? " 🔽"
                        : " 🔼"
                      : ""}
                  </span>
                  {column.render("Header")}
                </th>
              ))}
              {actions.length !== 0 ? (
                <th scope="col" className="relative py-3.5 pl-3 pr-4 sm:pr-3">
                  <span className="sr-only">Edit</span>
                </th>
              ) : (
                ""
              )}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {page.map((row, idx) => {
            prepareRow(row);
            return (
              <tr
                {...row.getRowProps()}
                className={idx % 2 === 0 ? undefined : "bg-gray-200"}
              >
                {row.cells.map((cell) => {
                  return (
                    <td
                      {...cell.getCellProps()}
                      className="px-3 py-4 text-sm text-gray-500"
                    >
                      {cell.render("Cell")}
                    </td>
                  );
                })}
                {actions.length !== 0 ? (
                  <td>
                    <div className="flex flex-row justify-end items-center gap-2">
                      {!row.original.hasOwnProperty("scheduleStatus")
                        ? actions.map((action, index) => (
                            <button
                              key={index}
                              className={action.styles}
                              onClick={() => action.handler(row.original)}
                            >
                              <action.icon />
                            </button>
                          ))
                        : actions.map((action, index) =>
                            row.original.scheduleStatus === "pending" ? (
                              <button
                                key={index}
                                // rowData={row.original}
                                className={action.styles}
                                onClick={() => action.handler(row.original)}
                              >
                                <action.icon />
                              </button>
                            ) : index === 0 ? (
                              <button
                                name="inprogress-delete"
                                key={index}
                                className={action.styles}
                                onClick={() => action.handler(row.original)}
                              >
                                <action.icon />
                              </button>
                            ) : (
                              ""
                            )
                          )}
                    </div>
                  </td>
                ) : (
                  ""
                )}
              </tr>
            );
          })}
        </tbody>
      </table>
      <div className="mt-10 flex justify-between items-center">
        <div className="flex flex-row justify-between items-center gap-6">
          <button
            className="h-8 w-8 hover:bg-gray-200 transition-all p-2"
            onClick={() => gotoPage(0)}
            disabled={!canPreviousPage}
          >
            <ChevronDoubleLeftIcon />
          </button>
          <button
            className="h-8 w-8 hover:bg-gray-200 transition-all p-2"
            onClick={() => previousPage()}
            disabled={!canPreviousPage}
          >
            <ChevronLeftIcon />
          </button>
          <button
            className="h-8 w-8 hover:bg-gray-200 transition-all p-2"
            onClick={() => nextPage()}
            disabled={!canNextPage}
          >
            <ChevronRightIcon />
          </button>
          <button
            className="h-8 w-8 hover:bg-gray-200 transition-all p-2"
            onClick={() => gotoPage(pageCount - 1)}
            disabled={!canNextPage}
          >
            <ChevronDoubleRightIcon />
          </button>{" "}
        </div>

        <div className="flex flex-row justify-between items-center gap-2 text-sm">
          <span>
            Total Records:{" "}
            <strong className="  font-bold text-indigo-500">
              {totalCount}
            </strong>{" "}
            | Page{" "}
            <strong className="  font-bold text-indigo-500">
              {pageIndex + 1} of {pageOptions.length}
            </strong>{" "}
          </span>
          <span>
            | Go to page:{" "}
            <input
              className="w-[100px] rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:max-w-xs sm:text-sm"
              type="number"
              // defaultValue={pageIndex + 1}
              value={pageIndex + 1}
              onChange={(e) => {
                const page = e.target.value ? Number(e.target.value) - 1 : 0;
                gotoPage(page);
              }}
            />
          </span>{" "}
          <select
            className="max-w-sm rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:max-w-xs sm:text-sm"
            value={pageSize}
            onChange={(e) => {
              setPageSize(Number(e.target.value));
            }}
          >
            {[10, 20, 30, 40, 50].map((pageSize) => (
              <option key={pageSize} value={pageSize}>
                Show {pageSize}
              </option>
            ))}
          </select>
        </div>
      </div>
    </>
  );
};

export default Table;
